import { TextBlock } from '../schema';

export default function isEmptyParagraph(block: TextBlock) {
  return (
    block.type === 'paragraph' &&
    Array.isArray(block.content) &&
    block.content.length === 0
  );
}
